var _rect, _path, _path2, _path3, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgGarageDoor = function SvgGarageDoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98 31H22v54h76V31z",
    fill: "#DFDFE9",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 43H30v6h60v-6zM90 49H30v6h60v-6zM90 55H30v6h60v-6zM90 61H30v6h60v-6zM90 67H30v6h60v-6zM90 73H30v6h60v-6zM90 79H30v6h60v-6z",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95 62.938V59a1 1 0 10-2 0v4.063c0 .517.42.937.938.937.586 0 1.062-.476 1.062-1.063zM93.938 70H94a1 1 0 10-1-1v.063c0 .517.42.937.938.937zM93.938 73H94a1 1 0 10-1-1v.063c0 .517.42.937.938.937zM93.938 76H94a1 1 0 10-1-1v.063c0 .517.42.937.938.937zM21 85h78v3a1 1 0 01-1 1H22a1 1 0 01-1-1v-3z",
    fill: "#332C4A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 82,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 35,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 2
  })));
};

export default SvgGarageDoor;